export const combineClasses = (...classNames) => classNames.filter(name => !!name).join(' ').trim();

export const randomNumber = (min, max) => {  
  return Math.floor(Math.random() * (max - min) + min); 
}